import { get, del } from '../client'

export const getAllProductVariants = () => get(`product_variants`)

export const deleteProductVariant = (variantId) => del(`product_variants/${variantId}`)
